var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgFilmLinecomponent = function SvgFilmLinecomponent(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#film-line_component_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.5 2.995a.75.75 0 0 1 .744-.745h13.512c.411 0 .744.334.744.745v12.01a.75.75 0 0 1-.744.745H2.244a.745.745 0 0 1-.744-.745V2.995ZM6 3.75v10.5h6V3.75H6Zm-3 0v1.5h1.5v-1.5H3Zm10.5 0v1.5H15v-1.5h-1.5ZM3 6.75v1.5h1.5v-1.5H3Zm10.5 0v1.5H15v-1.5h-1.5ZM3 9.75v1.5h1.5v-1.5H3Zm10.5 0v1.5H15v-1.5h-1.5Zm-10.5 3v1.5h1.5v-1.5H3Zm10.5 0v1.5H15v-1.5h-1.5Z",
    fill: "#A08264"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "film-line_component_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h18v18H0z"
  })))));
};
export default SvgFilmLinecomponent;